import React from 'react'
import { FormikProvider } from 'formik'

import useVehicle from './useVehicle'
// import HubspotFormComp from 'pages/HubspotForm'
// import Modal from 'react-modal'

import CustomCheckboxField from 'atoms/CustomCheckboxField/CustomCheckboxField'
// import Label from 'atoms/Label'
import TextField from 'molecules/CustomTextField/CustomTextField'
import { allWeekDays, auxiliary_load_options, terrainOptions } from '../helpers/hv_options'
import CustomSelect from 'atoms/CustomSelect'

import {
  StyledRoot,
  StyledSection,
  StyledTypography,
  StyledFormControl,
  StyledMandatory,
  StyledWeeks,
  StyledButtonContainer,
  StyledCalculateButton,
  StyledGroupContainer,
  StyledInnerFormContainer,
} from '../Vehicle.style'

import Typography from 'atoms/Typography'
import styled from 'styled-components'
import { useModal } from 'hooks'

import AddVehicleModal from 'pages/AddVehicleModal/AddVehicleModal'
// import styled from 'styled-components'

const Vehicle = () => {
  const { openModal } = useModal()

  const {
    formik,
    iceChassisOptions,
    evChassisOptions,
    hvVehicleWeightClass,
    payload,
    hvTcoData,
    onHandleClickAddvehicle,
    onHandleClickUpdate,
  } = useVehicle()

  const { ice_chassis, replacement_electric_vehicle_chassis, heavy_vehicle_weight_class } =
    formik.values

  const vehicle_payload_validation =
    'vehicle_payload' in formik?.errors && formik.values.vehicle_payload

  const terrain_tooltip = (
    <StyledTooltipContainer>
      <p>Select Flat, Moderate or Steep terrain.</p>
      <p>Flat - no inclines </p>
      <p>Moderate - 20 - 30% incline over the trip</p>
      <p>Steep - over 50% incline over the trip</p>
    </StyledTooltipContainer>
  )

  // const onHandleUpdateArray = () => {

  // }

  const onHandleClickOpenModal = (fuel_type: string) => {
    openModal({
      name: 'add-vehicle-modal',
      data: {
        iceChassisOptions,
        evChassisOptions,
        hvVehicleWeightClass,
        fuel_type,
        hvTcoData,
        ice_chassis,
        replacement_electric_vehicle_chassis,
        heavy_vehicle_weight_class,
      },
    })
  }

  return (
    <>
      <StyledRoot>
        <StyledTypography variant="h2" weight={400}>
          Tell us about the vehicle you intend to replace and its duty cycle
        </StyledTypography>

        <FormikProvider value={formik}>
          <StyledSection>
            <StyledGroupHeader variant="h2">
              Select ICE chassis and replacement electric chassis
            </StyledGroupHeader>
            <StyledGroupContainer>
              <StyledFormControl>
                <StyledInnerFormContainer>
                  <Typography
                    variant="label"
                    weight={400}
                    color="#000"
                    tooltipId="heavy_vehicle_weight_class"
                    tooltip="Heavy vehicle asset class is the weight range classification according to industry segmentation"
                    as={'div'}
                  >
                    Heavy vehicle weight class <StyledMandatory>*</StyledMandatory>
                  </Typography>
                  <StyledCustomSelect
                    mandatory
                    name="heavy_vehicle_weight_class"
                    labelColor="#000"
                    placeholder="Heavy vehicle weight class"
                    options={hvVehicleWeightClass}
                  />
                </StyledInnerFormContainer>

                <StyledInnerFormContainer>
                  <Typography
                    variant="label"
                    weight={400}
                    color="#000"
                    tooltipId="ice_chassis"
                    tooltip="You can select predefined ICE chassis, add custom or update ICE chassis details"
                    as={'div'}
                  >
                    ICE Chassis <StyledMandatory>*</StyledMandatory>
                  </Typography>

                  <StyledModalColumn>
                    <StyledCustomSelect
                      mandatory
                      name="ice_chassis"
                      labelColor="#000"
                      placeholder="ICE chassis"
                      options={iceChassisOptions}
                      disabled={!formik?.values.heavy_vehicle_weight_class}
                      additionalInfo
                    />
                    <p onClick={() => onHandleClickOpenModal('diesel')}>Add / Update ICE chassis</p>
                  </StyledModalColumn>
                </StyledInnerFormContainer>
                <StyledInnerFormContainer>
                  <Typography
                    variant="label"
                    weight={400}
                    color="#000"
                    tooltipId="replacement_electric_vehicle_chassis"
                    tooltip="Select the replacement eV chassis or add custom eV chassis"
                    as={'div'}
                  >
                    Replacement ZeV chassis <StyledMandatory>*</StyledMandatory>
                  </Typography>

                  <StyledModalColumn>
                    <StyledCustomSelect
                      mandatory
                      name="replacement_electric_vehicle_chassis"
                      labelColor="#000"
                      placeholder="Replacement ZeV chassis"
                      options={evChassisOptions}
                      disabled={!formik?.values.heavy_vehicle_weight_class}
                      additionalInfo
                    />
                    <p onClick={() => onHandleClickOpenModal('electric')}>
                      Add / Update electric chassis
                    </p>
                  </StyledModalColumn>
                </StyledInnerFormContainer>
              </StyledFormControl>
            </StyledGroupContainer>
          </StyledSection>

          <StyledSection>
            <StyledGroupHeader variant="h2">Enter body details and cost</StyledGroupHeader>
            <StyledGroupContainer>
              <StyledFormControl>
                <StyledInnerFormContainer>
                  <Typography
                    variant="label"
                    weight={400}
                    color="#000"
                    tooltipId="vehicle_payload"
                    tooltip="Enter maximum body plus payload weight required for your vehicle that is supported by the chassis"
                    as={'div'}
                  >
                    Vehicle body plus payload weight
                    <StyledMandatory>*</StyledMandatory>
                  </Typography>
                  <StyledTextField
                    mandatory
                    name="vehicle_payload"
                    labelColor="#000"
                    placeholder="Vehicle body plus payload weight"
                    showError={false}
                    adornment={'kg'}
                    adornmentPosition="right"
                    numeric
                  />
                  <Typography
                    color={vehicle_payload_validation ? '#eb5757' : '#DBA315'}
                    variant="caption"
                  >
                    {payload
                      ? `The maximum payload supported by the eV chassis is  ${payload} kg `
                      : ''}
                  </Typography>
                </StyledInnerFormContainer>
                <StyledInnerFormContainer>
                  <Typography
                    variant="label"
                    weight={400}
                    color="#000"
                    tooltipId="auxiliary_load"
                    tooltip="The application would be used to determine the additional energy use"
                    as={'div'}
                  >
                    Application
                    <StyledMandatory>*</StyledMandatory>
                  </Typography>
                  <StyledCustomSelect
                    mandatory
                    name="auxiliary_load"
                    labelColor="#000"
                    placeholder="Auxiliary load"
                    options={auxiliary_load_options}
                  />
                </StyledInnerFormContainer>
                <StyledInnerFormContainer>
                  <Typography
                    variant="label"
                    weight={400}
                    color="#000"
                    tooltipId="body_coast"
                    tooltip="Enter the cost of the body that has been added to the vehicle"
                    as={'div'}
                  >
                    Body cost (AUD) <StyledMandatory>*</StyledMandatory>
                  </Typography>
                  <StyledTextField
                    mandatory
                    name="body_coast"
                    labelColor="#000"
                    placeholder="Body cost (AUD)"
                    numeric
                    adornment={'A$'}
                    adornmentPosition="left"
                  />
                </StyledInnerFormContainer>
              </StyledFormControl>
            </StyledGroupContainer>
          </StyledSection>

          <StyledSection mgTop={34}>
            <StyledGroupHeader variant="h2">
              Enter operating conditions of the vehicle
            </StyledGroupHeader>
            <StyledFormControl>
              <StyledInnerFormContainer>
                <Typography
                  variant="label"
                  weight={400}
                  color="#000"
                  tooltipId="working_days"
                  tooltip="Define the days of the week that your vehicle operates"
                  as={'div'}
                >
                  Working days <StyledMandatory>*</StyledMandatory>
                </Typography>

                <StyledWeeks>
                  {allWeekDays.map((item) => (
                    <CustomCheckboxField
                      name="working_days"
                      key={item.value}
                      value={item.value}
                      label={item.label}
                    />
                  ))}
                </StyledWeeks>
              </StyledInnerFormContainer>
              <StyledGroupContainer>
                <StyledFormControl>
                  <StyledInnerFormContainer>
                    <Typography
                      variant="label"
                      weight={400}
                      color="#000"
                      tooltipId="distance_travelled_per_day"
                      tooltip="Enter the average distance travelled by your vehicle in a day"
                      as={'div'}
                    >
                      Distance travelled per day <StyledMandatory>*</StyledMandatory>
                    </Typography>
                    <StyledTextField
                      // mandatory
                      name="distance_travelled_per_day"
                      labelColor="#000"
                      placeholder="Distance travelled per day"
                      numeric
                      adornment={'km'}
                      adornmentPosition="right"
                    />
                  </StyledInnerFormContainer>
                  <StyledInnerFormContainer>
                    <Typography
                      variant="label"
                      weight={400}
                      color="#000"
                      tooltipId="terrain"
                      tooltip={terrain_tooltip}
                      as={'div'}
                    >
                      Terrain <StyledMandatory>*</StyledMandatory>
                    </Typography>
                    <StyledCustomSelect
                      mandatory
                      name="terrain"
                      labelColor="#000"
                      placeholder="Terrain *"
                      options={terrainOptions}
                    />
                  </StyledInnerFormContainer>
                </StyledFormControl>
              </StyledGroupContainer>
            </StyledFormControl>
          </StyledSection>

          <StyledButtonContainer>
            <StyledCalculateButton onClick={() => formik.handleSubmit()} color="#19B3FF">
              Calculate
            </StyledCalculateButton>
          </StyledButtonContainer>
        </FormikProvider>
      </StyledRoot>
      {/* <Modal isOpen={openModal} onRequestClose={onModalHandleClick}>
        <HubspotFormComp onModalHandleClick={onModalClose} />
      </Modal> */}
      <AddVehicleModal
        onHandleClickUpdate={onHandleClickUpdate}
        onHandleClickAddvehicle={onHandleClickAddvehicle}
      />
    </>
  )
}
export default Vehicle

const StyledGroupHeader = styled(Typography)`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  color: #000000;
  padding-bottom: 24px;
`

const StyledModalColumn = styled.div`
  display: grid;
  grid-template-columns: 350px 210px;
  align-items: center;
  gap: 40px;
  p {
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: #19b3ff;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`

const StyledTextField = styled(TextField)`
  min-width: 350px;
  max-width: 350px;
  @media (max-width: 768px) {
    min-width: unset;
    max-width: unset;
    width: 100%;
  }
`

export const StyledCustomSelect = styled(CustomSelect)`
  background-color: #fff;
  min-width: 350px;
  max-width: 350px;
  @media (max-width: 768px) {
    min-width: unset;
    max-width: unset;
    width: 100%;
  }
`
const StyledTooltipContainer = styled.div`
  p {
    color: #fff;
  }
`
